import { graphql } from "gatsby"
import React from "react"
import Hero from "../molecules/hero"
import BlockQuote from "../molecules/block-quote"
import Waterfall from "./waterfall/waterfall"
import PhotoGalleryCover from "./photo-gallery/photo-gallery-cover"
import TextContent from "../molecules/text-content"
import ColumnsSection from "./columns_section"
import FeatureText from "../molecules/feature-text"
import HeroBanner from "../molecules/hero-banner"

const DynamicZone = ({ components }) => {
  return components.map(container => {
    const key = `${container.__typename}_${container.id}`
    switch (container.__typename) {
      case `FT_ComponentMoleculesBanner`:
        return <HeroBanner key={key} data={container} />
      case `FT_ComponentMoleculesHero`:
        return <Hero key={key} data={container} />
      case `FT_ComponentMoleculesBlockquote`:
        return <BlockQuote key={key} data={container} />
      case `FT_ComponentOrganismsWaterfall`:
        return <Waterfall key={key} data={container} />
      case `FT_ComponentOrganismsPhotoGallery`:
        return <PhotoGalleryCover key={key} data={container} />
      case `FT_ComponentMoleculesTextContent`:
        return <TextContent key={key} data={container} />
      case `FT_ComponentOrganismsColumnsSection`:
        return <ColumnsSection key={key} data={container} />
      case `FT_ComponentMoleculesFeatureText`:
        return <FeatureText key={key} data={container} />
      default:
        return null
    }
  })
}

export const query = graphql`
  fragment DynamicZone on FT_StoryContainersDynamicZone {
    ... on FT_ComponentMoleculesHero {
      id
      __typename
      ...Hero
    }
    ... on FT_ComponentMoleculesBlockquote {
      id
      __typename
      ...BlockQuote
    }
    ... on FT_ComponentOrganismsWaterfall {
      id
      __typename
      ...Waterfall
    }
    ... on FT_ComponentOrganismsColumnsSection {
      __typename
      ...ColumnsSection
    }
    ... on FT_ComponentMoleculesTextContent {
      id
      __typename
      ...TextContent
    }
    ... on FT_ComponentOrganismsPhotoGallery {
      id
      __typename
      ...PhotoGallery
    }
    ... on FT_ComponentMoleculesFeatureText {
      __typename
      ...FeatureText
    }
  }

  fragment FilmakersDZ on FT_MeetTheFilmakersContainersDynamicZone {
    ... on FT_ComponentMoleculesBanner {
      id
      __typename
      ...HeroBanner
    }
    ... on FT_ComponentOrganismsWaterfall {
      id
      __typename
      ...Waterfall
    }
    ... on FT_ComponentOrganismsColumnsSection {
      id
      __typename
      ...ColumnsSection
    }
    ... on FT_ComponentMoleculesFeatureText {
      id
      __typename
      ...FeatureText
    }
    ... on FT_ComponentMoleculesTextContent {
      id
      __typename
      ...TextContent
    }
  }

  fragment GetInvolvedDZ on FT_GetInvolvedContainersDynamicZone {
    ... on FT_ComponentMoleculesBanner {
      id
      __typename
      ...HeroBanner
    }
    ... on FT_ComponentOrganismsWaterfall {
      id
      __typename
      ...Waterfall
    }
    ... on FT_ComponentOrganismsColumnsSection {
      id
      __typename
      ...ColumnsSection
    }
    ... on FT_ComponentMoleculesFeatureText {
      id
      __typename
      ...FeatureText
    }
    ... on FT_ComponentMoleculesTextContent {
      id
      __typename
      ...TextContent
    }
  }
`

export default DynamicZone
